import React from 'react'

export default abstract class MeasurIcon<
  P = Record<string, never>,
> extends React.Component<P> {
  override shouldComponentUpdate() {
    return false
  }
}
